'use client';

import { c as _c } from "react/compiler-runtime";
import { useInterval } from 'ahooks';
import dayjs from 'dayjs';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
export function UDT(t0) {
  const $ = _c(12);
  let {
    dt,
    className
  } = t0;
  let t1;
  if ($[0] !== dt) {
    t1 = dt ? dayjs(dt).fromNow() : null;
    $[0] = dt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [fromNow, setFromNow] = useState(t1);
  let t2;
  if ($[2] !== dt) {
    t2 = () => {
      setFromNow(dayjs(dt).fromNow());
    };
    $[2] = dt;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useInterval(t2, dt ? 60000 : undefined);
  if (!dt) {
    return null;
  }
  let t3;
  if ($[4] !== className) {
    t3 = twMerge("text-sm font-light flex items-center gap-x-1.5 py-1", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  className = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span>Updated</span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== fromNow) {
    t5 = <span>{fromNow}</span>;
    $[7] = fromNow;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== className || $[10] !== t5) {
    t6 = <div className={className}>{t4}{t5}</div>;
    $[9] = className;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}